module.exports = function hasRelationship(rel) {
	return (
		!!rel &&
		((!Array.isArray(rel.data) && rel.data !== null) ||
			(Array.isArray(rel.data) && rel.data.length > 0))
	);
};
